import '../style/link-Dmko3W9H.css'
import { defineComponent as l, toRef as u, resolveComponent as b, withDirectives as f, h as c } from "vue";
import { useLink as m } from "./hooks/useLink.js";
import s from "./directives/ripple.js";
const v = /* @__PURE__ */ l({
  name: "e-link",
  props: {
    to: [String, Object],
    newTab: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: void 0
    },
    withStyle: Boolean,
    tag: String,
    a11yAttrs: Object,
    buttonProps: Object
  },
  setup(t, {
    slots: e
  }) {
    const o = u(t, "to"), {
      nativeTag: a,
      isRoute: n,
      rawProps: i
    } = m({
      to: o,
      newTab: t.newTab,
      tag: t.tag,
      withStyle: t.withStyle,
      buttonProps: t.buttonProps
    }), r = b("RouterLink");
    return () => f(c(n.value ? r : a.value, {
      role: "link",
      ...i.value,
      ...t.a11yAttrs
    }, n.value ? () => e.default?.() : e.default?.()), [[s, t.ripple ?? !0]]);
  }
});
export {
  v as default
};
//# sourceMappingURL=link.js.map
